'use client';

import { useEffect } from 'react';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { GTMEventType } from '@/lib/GTMEventType';

type Props = {
  searchTerm: string;
  quantity: number;
};

export function SearchPageGTMReporter({ searchTerm, quantity }: Props) {
  useEffect(() => {
    sendGTMEvent({
      event: GTMEventType.SEARCH,
      search_term: searchTerm,
      search_quantity: quantity.toString(),
      eventModel: { search_term: searchTerm },
    });
  }, [searchTerm, quantity]);

  return null;
}
